import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import DashboardSidebar from "./DashboardSidebar";
import DashboardHome from "../Dashboard/AnalysisAndExtract/DashboardHome";
import Void from "./Voids/Void";
import Void2 from "./Voids/Void2";
import Void3 from "./Voids/Void3";
import DataAnalysisSummary from "../Dashboard/AnalysisAndExtract//DataAnalysisSummary";
import AIChatBotSideBar from "./AIChatBot/AIChatBotSideBar";
import AIChatBot from "./AIChatBot/AIChatBot";
import AIModelsChatBotSideBar from "./AIModules/AIChatBot/AIChatBotSideBar";
import AIModelsChatBot from "./AIModules/AIChatBot/AIChatBot";
import PDFExtractorComparator from "../Dashboard/AnalysisAndExtract//PDFExtractorComparator";
import { PanelLeft, Menu } from "lucide-react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouterHooks } from "../../withRouters/withRoutersHook";
import {
  CollapseCX2SidebarActiveAction,
  CollapseCX2SidebarInactiveAction,
} from "../../Actions/Interactions";
import FileProcessedSuccess from "../Dashboard/AnalysisAndExtract/FileProcessedSuccess";
import { ResetAnalysisReduxStateAction } from "../../Actions/Analysis";
import Messaging from "./Messaging/Overview/Messaging";
import MessagingSideBar from "./Messaging/MessagingSideBar";
import Whatsapp from "./Messaging/WhatsApp/Whatsapp";
import Email from "./Messaging/Email/Email";
import SmartFlowHome from "../Dashboard/SmartFlow/SmartFlowHome";
import AIModuleHome from "./AIModules/AIModuleHome";
import SmartflowPreview from "./SmartFlow/SmartflowPreview";
import PDFTemplateUpload from "./SmartFlow/PDFTemplateUpload";
import PDFTemplateMapper from "./SmartFlow/PDFTemplateMapper";
import PDFTemplateInstanceFill from "./SmartFlow/PDFTemplateInstanceFill";
import PDFTemplatePreview from "./SmartFlow/PDFTemplatePreview";
import Calls from "./Messaging/PhoneCalls/Calls";
import FileManagerHome from "./FileManager/FileManagerhome";
import Settings from "./Settings/Settings";
import Analytics from "./Analytics/Amalytics";
import DocsHome from "./Docs/DocsHome";

class DashboardRouter extends Component {
  static propTypes = {
    isCollapsed: PropTypes.bool,
    CollapseCX2SidebarActiveAction: PropTypes.func.isRequired,
    CollapseCX2SidebarInactiveAction: PropTypes.func.isRequired,
    pdfAnalysisSuccess: PropTypes.bool,
    ResetAnalysisReduxStateAction: PropTypes.func.isRequired,
    isSentToMail: PropTypes.bool,
    csvAnalysisSuccess: PropTypes.bool,
  };

  state = {
    showSuccessPopup: false,
    showMobileSidebar: false,
    isMobileView: false,
  };

  popupTimeout = null;

  componentDidMount() {
    // Add resize listener for mobile view detection
    this.checkMobileView();
    // Use debounced version of checkMobileView to prevent too many state updates
    this.debouncedCheckMobileView = this.debounce(this.checkMobileView, 250);
    window.addEventListener("resize", this.debouncedCheckMobileView);
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.pdfAnalysisSuccess &&
        this.props.pdfAnalysisSuccess !== prevProps.pdfAnalysisSuccess &&
        !this.props.isSentToMail) ||
      (this.props.csvAnalysisSuccess &&
        this.props.csvAnalysisSuccess !== prevProps.csvAnalysisSuccess &&
        !this.props.isSentToMail)
    ) {
      console.log("this got triggered");
      this.setState({ showSuccessPopup: true });

      // Clear any previous timeout before setting a new one
      clearTimeout(this.popupTimeout);
      this.popupTimeout = setTimeout(() => {
        this.setState({ showSuccessPopup: false });
        if (
          this.props.location.pathname.includes("/dashboard/result-summary/")
        ) {
          return;
        } else {
          this.props.ResetAnalysisReduxStateAction();
        }
      }, 8000);
    }
  }

  componentWillUnmount() {
    // Clear timeout if component unmounts to prevent memory leaks
    clearTimeout(this.popupTimeout);
    // Clear debounce timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    // Remove resize listener
    window.removeEventListener("resize", this.debouncedCheckMobileView);
  }

  // Debounce function to limit how often a function can be called
  debounce = (func, delay) => {
    return (...args) => {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  checkMobileView = () => {
    const isMobile = window.innerWidth < 768;
    // Only update state if the value has changed to prevent unnecessary renders
    if (this.state.isMobileView !== isMobile) {
      this.setState({ isMobileView: isMobile });
    }
  };

  handleCollapseEnable = () => {
    if (this.props.isCollapsed) {
      this.props.CollapseCX2SidebarInactiveAction();
    } else {
      this.props.CollapseCX2SidebarActiveAction();
    }
  };

  toggleMobileSidebar = () => {
    this.setState({ showMobileSidebar: !this.state.showMobileSidebar });
  };

  handleToggle = () => {
    if (this.state.isMobileView) {
      this.toggleMobileSidebar();
    } else {
      this.handleCollapseEnable();
    }
  };

  render() {
    const { showMobileSidebar, isMobileView } = this.state;

    // Mobile menu button component
    const MobileMenuButton = () => (
      <button
        className="fixed z-50 top-4 left-4 md:hidden bg-white p-2 rounded-md shadow-md"
        onClick={this.toggleMobileSidebar}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d={
              showMobileSidebar
                ? "M6 18L18 6M6 6l12 12"
                : "M4 6h16M4 12h16M4 18h16"
            }
          />
        </svg>
      </button>
    );

    // Shared layout for dashboard routes
    const DashboardLayout = ({ children }) => (
      <div className="flex w-full h-screen overflow-hidden">
        {/* Desktop Sidebar — absolute overlay, expands on hover */}
        <div className="hidden md:block absolute top-0 left-0 h-full z-30">
          <DashboardSidebar />
        </div>

        {/* Mobile Sidebar - conditionally rendered */}
        {showMobileSidebar && (
          <div className="md:hidden fixed top-0 left-0 z-40 h-full">
            <DashboardSidebar />
          </div>
        )}

        {/* Mobile Menu Button */}
        <MobileMenuButton />

        {/* Content area — offset by collapsed sidebar width (w-14 = 3.5rem) */}
        <div className="flex w-full flex-col md:flex-row overflow-y-auto md:pl-14">
          {children}
          {this.state.showSuccessPopup && <FileProcessedSuccess />}
        </div>
      </div>
    );

    // Same pattern for AI chatbot routes
    const AIChatbotLayout = ({ children }) => (
      <div className="flex w-full h-screen overflow-hidden">
        {/* Desktop Sidebar */}
        <div className="hidden md:block relative z-[100] flex-shrink-0">
          <AIChatBotSideBar
            toggleSidebar={this.toggleMobileSidebar}
            isCollapsed={this.props.isCollapsed}
          />
        </div>

        {/* Mobile Sidebar - conditionally rendered */}
        {showMobileSidebar && (
          <div className="md:hidden fixed top-0 left-0 z-[100] h-full">
            <AIChatBotSideBar
              toggleSidebar={this.toggleMobileSidebar}
              isCollapsed={!showMobileSidebar}
            />
          </div>
        )}

        {/* Re-open button for desktop - visible only when sidebar is collapsed */}
        {this.props.isCollapsed && (
          <button
            className="hidden md:flex fixed z-[150] top-5 left-4 p-1.5 rounded-md text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors"
            onClick={this.handleCollapseEnable}
            title="Open sidebar"
          >
            <PanelLeft className="w-4 h-4" />
          </button>
        )}

        {/* Mobile Menu Button */}
        <button
          onClick={this.toggleMobileSidebar}
          className="fixed top-4 left-4 z-[200] md:hidden p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors"
        >
          <Menu className="w-5 h-5" />
        </button>

        <div
          className={`flex w-full flex-col md:flex-row overflow-y-auto ${
            this.props.isCollapsed ? "ml-0" : "ml-0 md:ml-[0.5rem]"
          }`}
        >
          {children}
          {this.state.showSuccessPopup && <FileProcessedSuccess />}
        </div>
      </div>
    );

    // Similar layout for Messaging routes
    const MessagingLayout = ({ children }) => (
      <div className="flex w-full h-screen overflow-hidden">
        {/* Desktop Sidebar */}
        <div className="hidden md:block flex-shrink-0">
          <MessagingSideBar />
        </div>

        {/* Mobile Sidebar - conditionally rendered */}
        {showMobileSidebar && (
          <div className="md:hidden fixed top-0 left-0 z-40 h-full">
            <MessagingSideBar />
          </div>
        )}

        {/* Mobile Menu Button */}
        <MobileMenuButton />

        <div className="flex w-full overflow-y-auto flex-col md:flex-row">
          {children}
        </div>
      </div>
    );

    // Simple full-width layout for other routes
    const FullWidthLayout = ({ children }) => (
      <div className="flex w-full h-screen overflow-hidden">
        <div className="flex w-full overflow-y-auto">{children}</div>
      </div>
    );

    return (
      <Routes>
        <Route
          path="/"
          element={
            <DashboardLayout>
              <DashboardHome />
            </DashboardLayout>
          }
        />
        <Route
          path="/pdf-analyzer"
          element={
            <DashboardLayout>
              <DashboardHome />
            </DashboardLayout>
          }
        />
        <Route
          path="/result-summary/:id"
          element={
            <DashboardLayout>
              <DataAnalysisSummary />
            </DashboardLayout>
          }
        />
        <Route
          path="/pdf-analyzer/result-summary/:id"
          element={
            <DashboardLayout>
              <DataAnalysisSummary />
            </DashboardLayout>
          }
        />
        <Route
          path="/ai-chatbot"
          element={
            <AIChatbotLayout>
              <AIChatBot />
            </AIChatbotLayout>
          }
        />
        <Route
          path="/ai-chatbot/:sessionId"
          element={
            <AIChatbotLayout>
              <AIChatBot />
            </AIChatbotLayout>
          }
        />
        <Route
          path="/pdf-analyzer/result-summary/:id/compare"
          element={
            <DashboardLayout>
              <PDFExtractorComparator />
            </DashboardLayout>
          }
        />
        <Route
          path="/message-overview"
          element={
            <MessagingLayout>
              <Messaging />
            </MessagingLayout>
          }
        />
        <Route
          path="/message-overview/whatsapp"
          element={
            <MessagingLayout>
              <Whatsapp />
            </MessagingLayout>
          }
        />
        <Route
          path="/message-overview/whatsapp/:id"
          element={
            <MessagingLayout>
              <Whatsapp />
            </MessagingLayout>
          }
        />
        <Route
          path="/message-overview/email"
          element={
            <MessagingLayout>
              <Email />
            </MessagingLayout>
          }
        />
        <Route
          path="/message-overview/calls"
          element={
            <MessagingLayout>
              <Calls />
            </MessagingLayout>
          }
        />
        <Route
          path="/smartflow"
          element={
            <DashboardLayout>
              <SmartFlowHome />
            </DashboardLayout>
          }
        />
        <Route
          path="/ai-models"
          element={
            <FullWidthLayout>
              <AIModuleHome />
            </FullWidthLayout>
          }
        />
        <Route
          path="/smartflow/preview/:id"
          element={
            <DashboardLayout>
              <SmartflowPreview />
            </DashboardLayout>
          }
        />
        <Route
          path="/smartflow/new"
          element={
            <DashboardLayout>
              <PDFTemplateUpload />
            </DashboardLayout>
          }
        />
        <Route
          path="/smartflow/:id/map"
          element={
            <DashboardLayout>
              <PDFTemplateMapper />
            </DashboardLayout>
          }
        />
        <Route
          path="/smartflow/:id/fill"
          element={
            <DashboardLayout>
              <PDFTemplateInstanceFill />
            </DashboardLayout>
          }
        />
        <Route
          path="/smartflow/instance/:id/preview"
          element={
            <DashboardLayout>
              <PDFTemplatePreview />
            </DashboardLayout>
          }
        />
        <Route
          path="/ai-models/ai-chatbot"
          element={
            <AIChatbotLayout>
              <AIModelsChatBot />
            </AIChatbotLayout>
          }
        />
        <Route
          path="/ai-models/ai-chatbot/:sessionId"
          element={
            <AIChatbotLayout>
              <AIModelsChatBot />
            </AIChatbotLayout>
          }
        />
        <Route
          path="/file-manager"
          element={
            <DashboardLayout>
              <FileManagerHome />
            </DashboardLayout>
          }
        />
        <Route
          path="/file-manager/knowledge-base"
          element={
            <DashboardLayout>
              <FileManagerHome />
            </DashboardLayout>
          }
        />
        <Route
          path="/file-manager/other-files"
          element={
            <DashboardLayout>
              <FileManagerHome />
            </DashboardLayout>
          }
        />
        <Route
          path="/file-manager/audit-log"
          element={
            <DashboardLayout>
              <FileManagerHome />
            </DashboardLayout>
          }
        />
        <Route
          path="/analytics"
          element={
            <DashboardLayout>
              <Analytics />
            </DashboardLayout>
          }
        />
        <Route
          path="/settings"
          element={
            <DashboardLayout>
              <Settings />
            </DashboardLayout>
          }
        />
        <Route
          path="/settings/account"
          element={
            <DashboardLayout>
              <Settings />
            </DashboardLayout>
          }
        />
        <Route
          path="/settings/admin"
          element={
            <DashboardLayout>
              <Settings />
            </DashboardLayout>
          }
        />
        <Route
          path="/settings/email-service"
          element={
            <DashboardLayout>
              <Settings />
            </DashboardLayout>
          }
        />
        <Route
          path="/docs"
          element={
            <FullWidthLayout>
              <DocsHome />
            </FullWidthLayout>
          }
        />
      </Routes>
    );
  }
}

const mapStateToProps = (state) => ({
  isCollapsed: state.interactions.isCollapsed,
  pdfAnalysisSuccess: state.analysis.pdfAnalysisSuccess,
  isSentToMail: state.analysis.isSentToMail,
  csvAnalysisSuccess: state.analysis.csvAnalysisSuccess,
});

const mapDispatchToProps = {
  CollapseCX2SidebarActiveAction,
  CollapseCX2SidebarInactiveAction,
  ResetAnalysisReduxStateAction,
};

export default withRouterHooks(
  connect(mapStateToProps, mapDispatchToProps)(DashboardRouter)
);
